import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _reduce from "lodash/reduce";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act';
import { getCurrentMortgageRates } from "../actions";
var reducer = createReducer(_defineProperty({}, getCurrentMortgageRates.success, function (state, payload) {
  var jsonData = _get(JSON.parse(payload), 'data');

  var currentRates = _reduce(jsonData, function (acc, value, key) {
    if (key !== 'excerpt') return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, parseFloat(value, 10)));
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value));
  }, {});

  return _objectSpread(_objectSpread({}, state), {}, {
    currentRates: currentRates
  });
}), {});
export default reducer;